module.exports = __webpack_public_path__ + "static/media/three-card-back.5358386e.svg";